import type { TileTerrain, Weather } from "../../models/worldState.ts";
import { resolveWeather } from "./resolveWeather.ts";
import {
  getDayNightPhaseForWeatherTurn,
  getSeasonForWeatherTurn,
} from "./weatherCalendar.ts";

/** Deterministic ambient weather from turn and clan tile terrain. */
export function resolveAmbientWeather(
  turn: number,
  terrain: TileTerrain,
): Weather {
  return resolveWeather(
    turn,
    terrain,
    getSeasonForWeatherTurn(turn),
    getDayNightPhaseForWeatherTurn(turn),
  );
}
